class BackNav {
    constructor() {
        this._init()
    }
    _init() {
        document.querySelectorAll('[data-back-nav]').forEach((el) => {
            el.addEventListener('click', () => {
                history.back()
            })
        })
    }
}


export default BackNav